import React, { useEffect, useState } from "react";
import axios from "../../api/axiosInstance";
import { ReelList } from "../../components/reel-list";

export const PropertyReelView = () => {
  const [reels, setReels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  // const [isMyReelsView, setIsMyReelsView] = useState(false);
  // const [isMyReelsView, setIsMyReelsView] = useState(() => {
  //   return localStorage.getItem("isMyReelsView") === "true";
  // });
  const getInitialReelView = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const isMyReelsParam = urlParams.get("myreels");

    if (isMyReelsParam === "true") {
      localStorage.setItem("isMyReelsView", "true");
      return true;
    }

    if (isMyReelsParam === "false") {
      localStorage.setItem("isMyReelsView", "false");
      return false;
    }

    return localStorage.getItem("isMyReelsView") === "true";
  };

  const [isMyReelsView, setIsMyReelsView] = useState(getInitialReelView);

  const [filters, setFilters] = useState(() => {
    const script = document.getElementById("reel-filters-data");
    return script ? JSON.parse(script.textContent) : [];
  });

  const el = document.getElementById("reel-root");

  const userId = parseInt(el?.dataset?.userid ?? 0);
  const projectId = parseInt(el?.dataset?.projectid ?? 0);

  useEffect(() => {
    const handleFiltersUpdate = () => {
      const updated = JSON.parse(
        document.getElementById("reel-filters-data")?.textContent || "[]"
      );
      setFilters(updated);
    };

    document.addEventListener("reelFiltersUpdated", handleFiltersUpdate);
    return () => {
      document.removeEventListener("reelFiltersUpdated", handleFiltersUpdate);
    };
  }, []);

  useEffect(() => {
    setPage(1);
    setReels([]);
    setHasMore(true);
    fetchReels(1, true);
  }, [userId, projectId, filters, isMyReelsView]);

  useEffect(() => {
    const handleStorageChange = () => {
      const value = localStorage.getItem("isMyReelsView") === "true";
      setIsMyReelsView(value);
    };

    window.addEventListener("reelToggleChanged", handleStorageChange);

    return () => {
      window.removeEventListener("reelToggleChanged", handleStorageChange);
    };
  }, []);

  const fetchReels = async (pageToLoad = 1, isReset = false) => {
    if (loading || (!hasMore && !isReset)) return;

    setLoading(true);
    try {
      let response;

      if (isMyReelsView) {
        // Fetch My List reels
        response = await axios.get(
          // `/Item/GetMyListFavoriteReel?userId=${userId}`
          `/Item/GetReelLikeCount?userId=${userId}`
        );
        const data = response?.data || [];
        setReels(data);
        setHasMore(false); // No pagination in favorites
      } else {
        // Fetch All reels
        response = await axios.post(
          `/Item/ListFilteredPropertyAll?userId=${userId}`,
          {
            Filters: filters,
            SortBy: "",
            PageNumber: pageToLoad,
            PageSize: 10,
            ProjectId: parseInt(projectId),
            IsExcelExport: false,
          }
        );

        const { ItemMaster = [], LastPage = 1 } = response?.data;
        setReels((prev) => (isReset ? ItemMaster : [...prev, ...ItemMaster]));
        setPage(pageToLoad);
        setHasMore(pageToLoad < LastPage);
      }
    } catch (err) {
      console.error("Failed to fetch reels:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleEndReached = () => {
    if (!loading && hasMore) {
      fetchReels(page + 1);
    }
  };

  const handleRemoveReelFromFavorite = (itemId) => {
    const updatedReels = reels.filter((r) => r.ItemId !== itemId);
    setReels([...updatedReels]);
  };

  const handleAddFavorite = async (itemId) => {
    try {
      const response = await axios.post(
        // `/Item/AddReelInFavorite?userId=${userId}`,
        `/Item/ReelLikeProperty?userId=${userId}`,

        { itemId: itemId }
      );

      if (response?.status === 200 && isMyReelsView)
        handleRemoveReelFromFavorite(itemId);

      return true;
    } catch (error) {
      console.error("Error adding favorite:", error);
      return false;
    }
  };

  const handleToggleReelView = () => {
    const next = !isMyReelsView;
    setIsMyReelsView(next);
    localStorage.setItem("isMyReelsView", next);
  };

  return (
    <>
      {!!userId && userId !== 0 && (
        <div className="reel-list-header">
          <button className="my-reel-button" onClick={handleToggleReelView}>
            {isMyReelsView ? (
              <>
                <i className="fas fa-list"></i> All Reels
              </>
            ) : (
              <>
                <i className="fas fa-bookmark"></i> My Reel List
              </>
            )}
          </button>
        </div>
      )}
      <ReelList
        userId={userId}
        properties={reels}
        onEndReached={handleEndReached}
        loading={loading}
        onAddFavorite={handleAddFavorite}
        isMyReelsView={isMyReelsView}
      />
    </>
  );
};
